export const colors = {
  tooltipLine: '#6A7692',
  dot: '#0B2140',
  dotStroke: 'white',
  backgroundLine: '#D9D9D9',
  axisTickLabel: '#6A7692',
  primary: '#627EEA',
  secondary: '#F2A52B',
}
